module.exports = __webpack_public_path__ + "img/certTJ5.8f95f823.jpg";